import React, { useEffect } from 'react';
import { autoScrollWindowForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { Icon } from 'js/components';

import RubricQuestionSet from './RubricQuestionSet';
import RubricEditorSaveBar from './RubricEditorSaveBar';
import { useRubricContext } from './RubricContext';

import styles from './RubricEditor.module.scss';

function RubricEditorBody() {
  const { rubric, createRubricQuestionSet } = useRubricContext();

  useEffect(() => {
    return autoScrollWindowForElements();
  }, []);

  return (
    <>
      {rubric?.document?.question_sets?.map((qs, index) => (
        <RubricQuestionSet
          key={qs.guid}
          questionSet={qs}
          questionSetIndex={index}
        />
      ))}
      <div className={styles['add-button-container']}>
        <button
          type="button"
          className={styles['add-button']}
          onClick={createRubricQuestionSet}
        >
          <i>
            <Icon icon="plus" className="btn-icon-left" />
          </i>
          Add question set
        </button>
      </div>
    </>
  );
}

export function RubricEditor({ onSave, saveName }) {
  return (
    <div className={styles['rubric-editor']}>
      <RubricEditorBody />
      <RubricEditorSaveBar onSave={onSave} saveName={saveName} />
    </div>
  );
}

export default RubricEditor;
